// test684
(684 && 0);
